import { createAction } from '@ngrx/store';

export const NOOP = createAction('[Root] NOOP');
